"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./CTAWithHeader.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _Video = _interopRequireDefault(require("../Video/Video"));
var _CTAWithHeaderMethods = require("./CTAWithHeaderMethods");
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CTAWithHeader = _ref => {
  let {
    alignment,
    variant,
    eyebrow,
    headline,
    isLongSubheader,
    subhead,
    content,
    buttons,
    textLinks,
    paddingClass,
    isPageHeader,
    Link,
    contentful_id,
    setVideoProgress,
    videoProgress
  } = _ref;
  const [maxButtonWidth, setMaxButtonWidth] = (0, _react.useState)(0);
  const buttonContainer = (0, _react.useRef)(null);
  let variantClass = null;
  let alignmentClass = null;
  const buttonsLight = {
    // blue buttons, for use on light backgrounds
    primary: "ter-button--primary--1",
    secondary: "ter-button--primary--2"
  };
  const buttonsDark = {
    // white buttons, for use on dark backgrounds
    primary: "ter-button--secondary--1",
    secondary: "ter-button--secondary--2"
  };
  let linksClass = "links-light";
  let buttonsVariants = buttonsLight;
  if (variant === "light") {
    variantClass = variant;
    buttonsVariants = buttonsDark;
  }
  if (variant === "dark") {
    variantClass = variant;
    buttonsVariants = buttonsDark;
    linksClass = "links-dark";
  }
  if (variant === "dark-gray") {
    variantClass = variant;
    buttonsVariants = buttonsDark;
    linksClass = "links-dark";
  }
  if (variant === "dark-navy") {
    variantClass = variant;
    buttonsVariants = buttonsDark;
    linksClass = "links-dark";
  }
  if (variant === "transparent-light-text") {
    variantClass = variant;
    buttonsVariants = buttonsDark;
    linksClass = "links-dark";
  }
  if (variant === "transparent-dark-text") {
    variantClass = variant;
  }
  if (alignment === "center") {
    alignmentClass = alignment;
  }
  (0, _react.useEffect)(() => {
    if (buttonContainer?.current?.childNodes && buttonContainer?.current?.childNodes?.length > 1) {
      buttonContainer?.current?.childNodes?.forEach(button => {
        if (button?.classList?.contains("ter-button")) {
          if (button?.offsetWidth > maxButtonWidth) {
            setMaxButtonWidth(button?.offsetWidth);
          }
        }
      });
    }
  }, [buttonContainer?.current?.childNodes]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `cta-container ${alignmentClass && alignmentClass} ${variantClass && variantClass} ${paddingClass}`,
    "data-sb-object-id": contentful_id
  }, (eyebrow || headline || subhead) && /*#__PURE__*/_react.default.createElement("div", {
    className: "header"
  }, eyebrow && /*#__PURE__*/(0, _react.createElement)(isPageHeader ? "h1" : "h2", {
    className: "eyebrow",
    "data-sb-field-path": contentful_id ? "eyebrow" : "tableEyebrow"
  }, eyebrow), headline && /*#__PURE__*/(0, _react.createElement)(eyebrow ? "h3" : isPageHeader ? "h1" : "h3", {
    className: "heading",
    "data-sb-field-path": contentful_id ? "headline" : "tableHeadline",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(headline)
  }, null), subhead && /*#__PURE__*/_react.default.createElement("p", {
    className: "subheading",
    "data-sb-field-path": contentful_id ? isLongSubheader ? "longSubhead" : "subhead" : "tableSubhead",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(subhead)
  })), content && /*#__PURE__*/_react.default.createElement("div", {
    className: `content content__bullet-theme--${variantClass}`,
    "data-sb-field-path": contentful_id ? "body" : "tableDescription",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(content)
  }), buttons?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: `cta-buttons ${textLinks && `text-links ${linksClass}`} cta-buttons--${alignmentClass} ${buttons?.length > 1 ? `cta-buttons--multiple` : ""} `,
    "data-sb-field-path": "ctaButtons",
    ref: buttonContainer
  }, buttons?.map((button, index) => {
    const external = (0, _checkForExternalLink.default)(button?.url);
    const buttonUrl = (0, _CTAWithHeaderMethods.checkForAnchors)(button);
    return button?.text && (textLinks ? /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "text-link-container"
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      contentfulId: button?.contentfulId,
      className: external ? "text-link-external" : "text-link",
      to: buttonUrl,
      video: button?.video,
      override: button?.override,
      setOverride: button?.setOverride,
      VideoComponent: _Video.default ? _Video.default : null,
      Link: Link,
      onClick: button?.onClick,
      videoProgress: videoProgress,
      setVideoProgress: setVideoProgress,
      style: maxButtonWidth > 0 && {
        minWidth: `${maxButtonWidth}px`,
        overflow: "hidden"
      }
    }, button.text)) : /*#__PURE__*/_react.default.createElement(_Button.default, {
      contentfulId: button?.contentfulId,
      key: index,
      className: (index + 1) % 2 !== 0 ? buttonsVariants?.primary : buttonsVariants?.secondary,
      url: buttonUrl,
      video: button?.video,
      override: button?.override,
      setOverride: button?.setOverride,
      VideoComponent: _Video.default ? _Video.default : null,
      Link: !external && Link,
      onClick: button?.onClick,
      videoProgress: videoProgress,
      setVideoProgress: setVideoProgress,
      inlineStyle: maxButtonWidth > 0 && {
        minWidth: `${maxButtonWidth}px`,
        overflow: "hidden"
      }
    }, button.text && button.text));
  })));
};
var _default = CTAWithHeader;
exports.default = _default;